// sagaHelpers.ts
import { call, put } from "redux-saga/effects";
import { constants } from "src/constants/common";
import { common } from "src/types/index";

export function* handleApiRequest({
  api,
  payload,
  successAction,
  errorAction,
  resolve,
  reject,
}: {
  api: (payload: any) => Promise<any>;
  payload: any;
  successAction: (data: any) => any;
  errorAction: (message: string) => any;
  resolve: (data: any) => void;
  reject: (err: any) => void;
}) {
  try {
    const response: common.ResponseGenerator = yield call(api, payload);

    if (!response)
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);

    if (Number(response?.code) === -1) throw new Error("Session Expire");

    if (Number(response?.code) === 0) throw new Error(response?.message);

    yield put(successAction(response?.data ?? response)); // flexible for add/list

    resolve(response);
  } catch (error) {
    const message =
      error instanceof Error
        ? error.message
        : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;

    yield put(errorAction(message));
    reject(error);
  }
}
